import { render, staticRenderFns } from "./RoomHealth.vue?vue&type=template&id=9016f922"
import script from "./RoomHealth.vue?vue&type=script&lang=js"
export * from "./RoomHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports